import { Link } from "react-router-dom";
import { Phone, ClipboardList } from "lucide-react";
import { BUSINESS } from "@/data/site";

export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-sky-200 bg-sky-50/95 backdrop-blur-lg p-3 shadow-[0_-4px_20px_rgba(2,132,199,0.15)]">
      <div className="flex items-center gap-3">
        <a
          href={BUSINESS.phoneHref}
          data-testid="mobile-sticky-call-button"
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-slate-100 py-3.5 text-sm font-bold text-slate-900 active:scale-[0.98] transition-transform"
        >
          <Phone className="h-4 w-4 text-sky-600" aria-hidden="true" />
          Call Now
        </a>
        <Link
          to="/quote"
          data-testid="mobile-sticky-quote-button"
          className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-sky-600 py-3.5 text-sm font-bold text-white shadow-md shadow-sky-600/25 active:scale-[0.98] transition-transform"
        >
          <ClipboardList className="h-4 w-4" aria-hidden="true" />
          Get a Quote
        </Link>
      </div>
    </div>
  );
}
